export enum ILessonStatus {
    Draft = 1,
    Published = 2
}